import Accordion from 'components/ui-components/Accordion';

import RTECompose from 'contentful/RTE_compose';
import { PlusIcon, MinusIcon } from 'assets/icons';
import { cefRed } from 'constants/variables';

import Container from './shared/container';
import { getAccessibleTextColorClass } from './shared/color_map';

const ContentfulAccordion = ({ fields }) => {
  const { name, faQs: accordionItems, backgroundColor } = fields;
  const transpiledData = accordionItems.map(
    ({ fields: itemFields, sys: { id } }, index) => ({
      id,
      index,
      title: itemFields?.question,
      content: (
        <div className="accordion-item__answer">
          <RTECompose content={itemFields?.answer} fieldType="content" />
        </div>
      ),
    }),
  );

  return (
    <Container isFullWidth className="pos-r" backgroundColor={backgroundColor}>
      <div className="evergreen__container-small m-0">
        {name && (
          <h3
            className={`competition__faq-title fw-800 fs-30 m-fs-32 ff-body mt-0 mb-24 ${getAccessibleTextColorClass(
              backgroundColor,
            )}`}>
            {name}
          </h3>
        )}
        <Accordion
          className={`m-0 p-0 evergreen__accordion${
            backgroundColor === 'black'
              ? ' evergreen__accordion--dark-background'
              : ''
          }`}
          iconClosed={
            <PlusIcon width="16" height="16" fillColor={cefRed} title="Open" />
          }
          iconOpen={
            <MinusIcon
              width="16"
              height="16"
              fillColor={cefRed}
              title="Close"
            />
          }
          accordionItems={transpiledData}
        />
      </div>
    </Container>
  );
};

export default ContentfulAccordion;
